<template>
  <div class="bg-white login">
    <div class="flex flex-col h-full w-full">
      <form class="flex flex-col gap-4" @submit.prevent="signin()">
        <div class="flex flex-col gap-4">
          <div class="text-lg font-extrabold">Anmelden</div>
          <div class="text-sm">
            Wenn Sie bei uns ein Benutzerkonto besitzen, melden Sie sich bitte an
          </div>
          <div>
            <input
              v-model="email"
              class="inp mail rounded-full"
              type="text"
              :class="invalid ? 'invalid' : ''"
              required
              placeholder="E-Mail-Adresse*"
              @focus="invalid = false"
            >
          </div>
          <div>
            <input
              v-model="pass"
              class="inp pass rounded-full"
              type="password"
              :class="invalid ? 'invalid' : ''"
              required
              placeholder="Passwort*"
              @focus="invalid = false"
            >
          </div>
        </div>
        <div>
          <div class="grid grid-cols-2 gap-4 items-center justify-between">
            <div class="grow">
              <button
                type="submit"
                class="text-center btn-primary block w-full font-bold rounded-full"
              >
                Anmelden
              </button>
              <div class="text-center font-bold">
                <div
                  class="text-sm py-4 text-primary cursor-pointer"
                  @click="$emit('navigateModal', 'PASSWORDRECOVER')"
                >
                  Passwort vergessen?
                </div>
              </div>
            </div>
            <div v-if="basisPaybackFeature"><button class="btn-primary bg-payback rounded-full w-full flex justify-center items-center gap-2 font-bold py-4" @click="login()"><BasicIcon :name="'payback'" class="w-5 scale-150" /> Login mit PAYBACK</button></div>
          </div>          
          <div class="overflow-hidden transition-all duration-1000" :class="invalid ? 'max-h-40' : 'max-h-0'">
            <div class="text-error bg-error-light border-error border text-sm text-center py-2 rounded mt-4">
              Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut
            </div>
          </div>
        </div>
      </form>
      <div v-if="showRegister" class="flex mt-4 flex-col gap-4">
        <div class="text-lg py-2 font-bold">Neu bei expert?</div>
        <div class="text-sm border-b pb-2">
          Registriere dich jetzt, um exklusive Angebote zu erhalten!
        </div>
        <button @click="login('keycloak', {prompt: 'create'})" class="text-center btn-primary block w-full font-bold">Jetzt registrieren</button>       
      </div>
      <div class="py-8">
        <div v-if="loggedIn" class="inline-block">
          <div class="bg-page-background rounded-xl p-4 flex flex-col gap-4 font-Payback">
            <div>Willkommen {{ user?.userName ?? 'Benutzername' }}!</div>
            <div>Eingeloggt seit {{ user?.loggedInAt ?? 'XX-XX-XXXX' }}</div>
            <div>
            <button class="btn-primary bg-payback-red px-8 rounded-full w-full" @click="logout()">
              Abmelden
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { user, login, loggedIn, logout } = useOidcAuth();
const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const basisPaybackFeature = computed(
  () =>
    featureStatePayback.value
    && (useFeatureValue('exsi-1556').value?.name == 'basic'
      || useFeatureValue('exsi-1556').value?.name == 'redemption'
      || useFeatureValue('exsi-1556').value?.name == 'full')
);
defineProps({
  doRedirect: {
    type: Boolean,
    default: true,
  },
  showRegister: {
    type: Boolean,
    default: true,
  },
});

const email = ref("");
const pass = ref("");
const invalid = ref(false);

async function signin() {
  login("keycloak", { "username": email.value, password: pass.value });
}
</script>
